import Vue from 'vue';

import { store } from '@/store'
import { mapState } from 'vuex';

import AbstractModel from "@/models/AbstractModel";
import VarianteQueryResult from '@/models/VarianteQueryResult'


export const KomponentenRepository = new Vue({

	store,
	data: function () {
		return {
			className: 'KomponentenRepository',
			globalCriteria: {},
			data: {}
		}
	},
	computed: {
		...mapState('settings', ['presets']),
		...mapState('configurator', ['configurator', 'kombis', 'komponenten']),
	},

	methods: {

		/**
		 * 	Fügt eine neue <Komponente> mit [<Variante>, <Variante>,...] 
		 * 	in das Repository ein
		 * 
		 */
		add( key, storage ) {
			var obj = {};
			obj[key] = storage;
			this.$store.commit('configurator/ADD_KOMPONENTE', obj);
		},
	
		/**
		 * 	Query an dieses Repository:
		 * 	Alle <Kombi> dieses Repositories holen
		 * 	
		 */
		findAll() {
			return this.komponenten || {};
		},

		/**
		 * 	Findet eine bestimmte Variante - ursprünglich im configurator.json
		 * 	die Property komponenten[key][variant]
		 * 
		 * 	find( 'flasche', 'gewinde' );	=> {title:'Gewinde', ...}
		 * 	find( 'flasche', 'gewinde' );	=> {title:'Gewinde', ...}
		 * 	find( 'flasche' );				=> {gewinde:{title:'Gewinde', ...}, farbe:{}, ...}
		 * 
		 */
		find( key, variant ) {
			
			// {typ:'flasche'} statt 'flasche' übergeben?
			if (typeof key == 'object') key = key.typ;
			if (typeof variant == 'object') variant = variant.typ;
	
			if (!this.komponenten[key]) return false;
			if (!variant) return this.komponenten[key].findAll();

			return this.komponenten[key].find(variant) || {};
		}
	}
});


// WEBPACK FOOTER //
// ./src/repositories/KomponentenRepository.js